module.exports = __webpack_public_path__ + "img/tinsoldier-thumb.308072ee.jpg";